// extracted by mini-css-extract-plugin
export var active = "_da-2";
export var recordingDot = "_da-1";
export var recordingIndicator = "_da-0";